import { renderToStaticMarkup } from "react-dom/server";

export const getVisibleTextFromNode = (node: React.ReactNode): string => {
  const html = renderToStaticMarkup(<>{node}</>);
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || "";
};
